// apps/client/src/routes/guards/RequireEdmEnabled.tsx
//
// Route gate for /leads/edm/*. Same predicate as the Lead Capture top nav
// (utils/edm isEdmEnabled), so a direct URL cannot render an eDM page for a
// company without `featureFlags.edm_broadcast === true`. AppLayout renders
// its Outlet only after company data loads, so a missing flag here means off,
// not "still loading" (the RequirePartnerNetworkAccess pattern). The eDM
// callables re-check the flag server-side.

import React from 'react';
import { useOutletContext, Navigate, Outlet } from 'react-router-dom';
import { isEdmEnabled } from '../../utils/edm';

interface AppOutletContext {
  companyData?: { featureFlags?: Record<string, unknown> | null } | null;
}

const RequireEdmEnabled: React.FC = () => {
  const outletContext = useOutletContext<AppOutletContext>();
  if (!isEdmEnabled(outletContext?.companyData?.featureFlags)) {
    return <Navigate to="/leads/inbox" replace />;
  }
  return <Outlet context={outletContext} />;
};

export default RequireEdmEnabled;
